import gql from "graphql-tag";

import { client } from "~/api/index";
import { CareCalendarWidget } from "~/bff-types/types";

const careCalendarWidgetQuery = async (): Promise<
  CareCalendarWidget | undefined
> => {
  const result = await client.query<{
    careCalendarWidget?: CareCalendarWidget;
  }>(gql`
    query careCalendarWidget {
      careCalendarWidget {
        state {
          __typename
          ... on CareCalendarEmptyWidget {
            title
            description
            bottomText
            target
            trackingData {
              ...trackingDataFields
            }
          }

          ... on CareCalendarQuickEntry {
            title
            description
            images
            imageText
            linkTeaser
            link {
              ...styledLinkFields
            }
            trackingData {
              ...trackingDataFields
            }
          }

          ... on CareCalendarTodoWidget {
            title
            description
            target
            bottomText
            todos {
              image
              title
            }
            trackingData {
              ...trackingDataFields
            }
          }
        }
      }
    }
    fragment styledLinkFields on StyledLink {
      style
      url
      title
      icon
    }

    fragment trackingDataFields on TrackingData {
      parameters {
        key
        value
        type
      }
    }
  `);

  return result.careCalendarWidget;
};

export default careCalendarWidgetQuery;
